<template>
  <div class="main">
    <div v-if="step==='appVersionMange'" class="AppVersionMange div-layout">
      <div class="AppVersionMange-main">
        <module-title title="版本记录">
          <div class="right">
            <el-button type="primary" size="medium" icon="el-icon-arrow-left" @click="$emit('back')">
              返回
            </el-button>
          </div>
        </module-title>
        <div class="AppVersionMange-main-contain">
          <el-table
            v-loading="listLoading"
            :data="applicationList"
            highlight-current-row
            fit
            element-loading-text="Loading"
            class="list-table"
          >
            <el-table-column type="index" width="55" align="center" label="序号" />
            <el-table-column label="应用名称" prop="campusAppName" align="center" width="250">
              <template slot-scope="scope">
                {{ scope.row.campusApp && scope.row.campusApp.name }}
              </template>
            </el-table-column>
            <el-table-column label="版本号" prop="versionCode" align="center" />
            <el-table-column label="迭代号" prop="iterationNumber" align="center" />
            <el-table-column label="发布时间" prop="updateDate" width="150px" />
            <el-table-column label="是否强制升级" prop="upgradeMethod" align="center">
              <template slot-scope="scope">
                <!-- <div
                    v-for="(item,index) in  scope.row.campusApp.upgradeMethodOptions"
                    :key="index"
                   >
                    {{item.name}}
                  </div> -->
                {{ scope.row.upgradeMethod?(scope.row.upgradeMethod===1?'是':'否'):'无' }}
              </template>
            </el-table-column>
            <el-table-column label="发布状态" prop="releaseStatus" align="center" width="120">
              <template slot-scope="scope">
                {{ scope.row.releaseStatus === 0 ? '未发布' : '已发布' }}
              </template>
            </el-table-column>
            <el-table-column label="启用状态" prop="versionNumber3" align="center" width="120">
              <template slot-scope="scope">
                {{ scope.row.releaseStatus === 0 ?'/':scope.row.status === 1 ? '启用' : scope.row.status === 0 ? '停用': '/' }}
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="500">
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  size="small"
                  @click="opAddOrEdit(scope.row.releaseStatus === 0 ? 'edit':'view', scope.row)"
                >
                  {{ scope.row.releaseStatus === 0 ? '编辑':'查看' }}
                </el-button>
                <el-button
                  v-if="!scope.row.releaseStatus||scope.row.campusApp.upgradeType"
                  type="success"
                  size="small"
                  icon="el-icon-position"
                  @click="publishAddApplication(scope.row)"
                >
                  发布
                </el-button>
                <el-button
                  v-if="scope.row.releaseStatus === 1&&scope.row.campusApp.upgradeType!==0 "
                  type="primary"
                  size="small"
                  @click="gotoHistoryMange(scope.row)"
                >
                  发布记录
                </el-button>
                <el-button
                  v-if="scope.row.releaseStatus === 0"
                  type="primary"
                  size="small"
                  @click="deleteAddApplication(scope.row)"
                >
                  删除
                </el-button>
                <el-button
                  v-show="(scope.row.status===1 || scope.row.status===0) && scope.row.releaseStatus === 1"
                  type="danger"
                  size="small"
                  @click="stopApplication(scope.row)"
                >
                  {{ scope.row.status ===1 ?'停用':'启用' }}
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <pagination
            :total="versionSearchForm.total"
            :page.sync="versionSearchForm.pageNum"
            :limit.sync="versionSearchForm.pageSize"
            @pagination="pageCurriculumList"
            @handleSizeChange="handleSizeChange"
          />
        </div>
      </div>
    </div>
    <!-- 发布版本 -->
    <el-dialog
      v-if="hiddenVariable.dialogpublishVisible"
      :close-on-click-modal="false"
      :visible.sync="hiddenVariable.dialogpublishVisible"
      title="发布版本"
      width="800px"
    >
      <el-form
        ref="versionPublishForm"
        :model="versionPublishForm"
        :rules="handleRules"
        label-position="right"
        label-width="150px"
      >
        <el-form-item label="应用名称：" prop="cunwAppId">
          <el-select
            v-model="versionPublishForm.cunwAppId"
            name="cunwAppId"
            size="medium"
            class="handle-form-input"
            :disabled="true"
          >
            <el-option
              v-for="item in upgradeAppList"
              :key="item.id + item.versionId"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <div v-if="versionPublishForm.upgradeType!==0">
          <el-form-item label="升级范围：" prop="upgradeRang">
            <el-radio-group v-model="versionPublishForm.upgradeRang">
              <el-radio :label="2">
                自定义范围
              </el-radio>
              <el-radio v-if="schoolGroupList.length>0" :label="1">
                到分组学校
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <div v-if="versionPublishForm.upgradeRang === 2">
            <el-form-item label="选择区域：" prop="areaCode">
              <el-cascader
                v-model="versionPublishForm.areaCode"
                :options="areaData"
                :props="areaProps"
                placeholder="全部省/市/区县"
                @change="handleChange"
              />
            </el-form-item>
            <el-form-item label="选择学校：" prop="schoolCode">
              <el-select
                v-model="versionPublishForm.schoolCode"
                name="schoolCode"
                size="medium"
                class="handle-form-input"
                placeholder="全部学校"
                filterable
                @change="handleChangeSchool"
              >
                <el-option
                  v-for="item in _schoollist"
                  :key="item.schoolCode"
                  :label="item.name"
                  :value="item.schoolCode"
                />
              </el-select>
            </el-form-item>
            <el-form-item
              v-if="versionPublishForm.upgradeType === 2"
              label="选择楼栋："
              prop="buildingId"
            >
              <el-select
                v-model="versionPublishForm.buildingId"
                name="buildingId"
                size="medium"
                multiple
                style="width: 200px"
                placeholder="全部楼栋"
                @change="handleChangeRoom"
              >
                <el-option
                  v-for="item in _roomlist"
                  :key="item.buildingId"
                  :label="item.buildingName"
                  :value="item.buildingId"
                />
              </el-select>
              <el-select
                v-model="versionPublishForm.roomId"
                name="roomId"
                size="medium"
                multiple
                style="margin-left: 5px; width: 200px"
                value-key="roomName"
                placeholder="全部教室"
                @change="handleChangeroomSimpleVOList"
              >
                <el-option-group
                  v-for="group in roomSimpleVOList"
                  :key="group.label"
                  :label="group.label"
                >
                  <el-option
                    v-for="item in group.options"
                    :key="item.roomId"
                    :label="item.roomName"
                    :value="item.roomId"
                  />
                </el-option-group>
              </el-select>
            </el-form-item>
            <el-form-item
              v-if="versionPublishForm.upgradeType === 1"
              label="选择班级："
              prop="upgradeType"
            >
              <el-select
                v-model="versionPublishForm.gradeId"
                name="gradeId"
                size="medium"
                multiple
                style="width: 200px"
                placeholder="全部年级"
                @change="handleupgradeType"
              >
                <el-option
                  v-for="item in _gradelist"
                  :key="item.grade"
                  :label="item.gradeName"
                  :value="item.grade"
                />
              </el-select>

              <el-select
                v-model="versionPublishForm.classCode"
                name="classCode"
                size="medium"
                multiple
                style="margin-left: 5px; width: 200px"
                placeholder="全部班级"
                value-key="name"
                @change="handleChangeclassVOList"
              >
                <el-option-group
                  v-for="group in classVOList"
                  :key="group.label"
                  :label="group.label"
                >
                  <el-option
                    v-for="item in group.options"
                    :key="item.name"
                    :label="item.name"
                    :value="item.code"
                  />
                </el-option-group>
              </el-select>
            </el-form-item>
          </div>
          <div v-else class="groupSchool">
            <el-checkbox-group v-model="versionPublishForm.schoolGroupIds">
              <el-card v-for="a in schoolGroupList" :key="a.id" class="box-card">
                <div slot="header" class="clearfix">
                  <el-checkbox :key="a.id" :label="a.id">
                    {{ a.name }}
                  </el-checkbox>
                </div>
                <div v-for="o in a.schools" :key="o.schoolCode" class="text item">
                  {{ o.name }}
                </div>
              </el-card>
            </el-checkbox-group>
          </div>
        </div>
        <el-form-item v-if="versionPublishForm.upgradeMethodOptions" label="选择升级方式：" prop="upgradeMethod">
          <el-radio-group
            v-model="versionPublishForm.upgradeMethod"
          >
            <el-radio
              v-for="item in versionPublishForm.upgradeMethodOptions"
              :key="item.code"
              :label="item.code"
            >
              {{ item.name }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          v-if="versionPublishForm.upgradeMethod === '1'"
          label="是否静默安装："
          prop="silentInstall"
        >
          <el-radio-group
            v-model="versionPublishForm.silentInstall"
          >
            <el-radio :label="1">
              是
            </el-radio>
            <el-radio :label="0">
              否
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <div v-if="versionPublishForm.silentInstall === 1 && versionPublishForm.upgradeMethod ==='1'">
          <el-form-item
            v-for="(item, index) in versionPublishForm.timesArry"
            :key="index"
            :label="index===0? '静默安装时间：':''"
            :prop="'timesArry.' + index + '.time'"
            :rules="{
              required: true, message: '静默安装时间不能为空', trigger: 'blur'
            }"
          >
            <el-time-picker
              v-model="item.time"
              is-range
              format="HH:mm"
              value-format="HH:mm"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              placeholder="选择时间范围"
            />
            <span
              v-if="index > 0"
              style="margin-left: 5px; color: red; font-size: 16px"
              class="el-icon-delete"
              @click="delTimes(index)"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-plus" plain style="width:70%" @click="addTimes">
              增加时间段规则
            </el-button>
          </el-form-item>
        </div>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button
          size="medium"
          @click="hiddenVariable.dialogpublishVisible = false"
        >
          取消
        </el-button>
        <el-button :loading="ajaxLoading" type="primary" size="medium" @click="handlepublish">
          {{
            ajaxLoading ? 'Loading' : '确定'
          }}
        </el-button>
      </div>
    </el-dialog>
    <AppHistoryRecord v-else-if="step === 'history'" :type-code="typeCode" :history-record-prpos="historyRecordPrpos" @back="back" />
    <EditVersion v-else-if="step === 'editVersion'" :id="handleRow.id" :handle-type="handleType" :type-code="typeCode" :terminal-list="terminalList" @back="back" />
  </div>
</template>

<script>
import EditVersion from './editVersion.vue';
import AppHistoryRecord from './versionManage/appHistoryRecord.vue';
import { getAppVersionList, deleteVersion, campusVersionsDisable, campusVersionsEnable, campusVersionsRelease } from '@/api/systemMaintenance/upgradeManage/versionManage';
import { campusAppGroupslist, campusAppsList } from '@/api/systemManage/softwareUpdate';
import { mapGetters } from 'vuex';

export default {
  name: 'AppVersionMange',
  components: {
    EditVersion, AppHistoryRecord
  },
  props: {
    typeCode: {
      type: String,
      default: ''
    },
    campusAppId: {
      type: String,
      default: ''
    },
    terminalList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      step: 'appVersionMange',
      // 搜索表单
      versionSearchForm: {
        pageNum: 1,
        total: 0,
        pageSize: 10
      },
      historyRecordPrpos: {},
      applicationList: [],
      listLoading: false,
      handleRow: {},
      // 全部控制显示隐藏变量
      hiddenVariable: {
        dialogpublishVisible: false
      },
      versionPublishForm: {
        cunwAppId: '',
        cunwAppUpgradeId: '',
        areaCode: '',
        schoolCode: '',
        buildingId: [],
        roomId: [],
        gradeId: [],
        classCode: [],
        upgradeType: '',
        upgradeMethod: '',
        upgradeMethodOptions: null,
        silentInstall: '',
        upgradeRang: 2,
        timesArry: [{ time: '' }],
        schoolGroupIds: [],
        status: ''
      },
      classVOList: [], // 班级列表
      classVOListResult: [],
      roomVOList: [], // 班级列表
      roomSimpleVOList: [], // 教室列表
      areaProps: {
        value: 'code',
        label: 'name',
        children: 'children',
        emitPath: false
      },
      handleRules: {
        areaCode: [{ required: true, message: '请选择区域', trigger: 'change' }],
        cunwAppId: [{ required: true, message: '请选择应用', trigger: 'change' }],
        versionCode: [{ required: true, message: '版本号不能为空', trigger: 'change' }],
        upgradeMethod: [{ required: true, message: '请选择升级方式', trigger: 'change' }],
        silentInstall: [{ required: true, message: '请选择静默安装方式', trigger: 'change' }]
      },
      schoolGroupList: [],
      upgradeAppList: [],
      ajaxLoading: false
    };
  },
  computed: {
    // 获取上传图片地址
    ...mapGetters(['uploadUrl', 'areaData', 'schoollist', 'roomlist', 'gradelist', 'userInfo']),
    _schoollist: {
      get() {
        return this.schoollist;
      },
      set(value) {
        if (value) {
          this.$store.dispatch('getNodesSchool', { empty: true });
        }
      }
    },
    _roomlist: {
      get() {
        return this.roomlist;
      },
      set(value) {
        if (value) {
          this.$store.dispatch('getNodesroom', { empty: true });
        }
      }
    },
    _gradelist: {
      get() {
        return this.gradelist;
      },
      set(value) {
        if (value) {
          this.$store.dispatch('getNodesclass', { empty: true });
        }
      }
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.fetchApplicationList();
      this.getApplicationList();
    },
    // 获取应用名称列表
    getApplicationList() {
      campusAppsList({ pageNum: 1, pageSize: 999 }, this.typeCode)
        .then((result) => {
          this.upgradeAppList = result.data.list.filter(v => v.status);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 分页
    pageCurriculumList(obj) {
      this.versionSearchForm.pageNum = obj.page;
      this.fetchApplicationList();
    },
    // 分页条数变化
    handleSizeChange(obj) {
      this.versionSearchForm.pageNum = 1;
      this.versionSearchForm.pageSize = obj.limit;
      this.fetchApplicationList();
    },
    // 条件查询
    handleSearchFilter() {
      this.versionSearchForm.pageNum = 1;
      this.versionSearchForm.pageSize = 10;
      this.fetchApplicationList();
    },
    fetchApplicationList() {
      console.log(this.versionSearchForm);
      this.listLoading = true;
      getAppVersionList({ ...this.versionSearchForm, typeCode: this.typeCode, campusAppId: this.campusAppId })
        .then((result) => {
          this.applicationList = result.data.list;
          this.versionSearchForm.total = result.data.total;
          this.listLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.listLoading = false;
          this.applicationList = [];
          this.versionSearchForm.total = 0;
        });
    },
    // 删除应用
    deleteAddApplication(row) {
      this.$confirm(`您确定删除数据吗？`, '删除数据', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => deleteVersion({ ids: [row.id] + '' }))
        .then((res) => {
          this.$notify.success({
            title: 'Success',
            message: '删除成功',
            showClose: false,
            duration: 2000
          });
          this.fetchApplicationList();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 停用启用应用
    stopApplication(row) {
      const name = row.status === 1 ? '停用' : '启用';
      this.$confirm(`您确定要${name}当前应用吗？`, `${name}应用`, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          var ids = [row.id] + '';
          if (row.status === 1) {
            return campusVersionsDisable({ ids });
          } else {
            return campusVersionsEnable({ ids });
          }
        })
        .then((res) => {
          this.$notify.success({
            title: 'Success',
            message: name + '成功',
            showClose: false,
            duration: 2000
          });
          this.fetchApplicationList();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 打开新增编辑弹框
    opAddOrEdit(type, row) {
      // 改用根据应用标识查询数据
      this.handleType = type;
      this.handleRow = row || {};
      this.step = 'editVersion';
    },
    back() {
      this.step = 'appVersionMange';
      this.fetchApplicationList();
    },
    addTimes() {
      this.versionPublishForm.timesArry.push({ time: '' });
    },
    delTimes(index) {
      this.versionPublishForm.timesArry.splice(index, 1);
    },
    // 发布应用
    publishAddApplication(row) {
      this.versionPublishForm.status = row.campusApp.status ? row.campusApp.status : null;
      if (!this.versionPublishForm.status) {
        this.$message({
          message: '该应用已被禁用，暂不可发布升级!',
          type: 'warning'
        });
        return;
      }
      var silentInstallTimeframes = row.silentInstallTimeframes ? row.silentInstallTimeframes : [];
      var times = [];
      silentInstallTimeframes.forEach(item => {
        times.push({ time: [item.startTime, item.endTime] });
      });
      this.hiddenVariable.dialogpublishVisible = true;
      this.versionPublishForm.cunwAppUpgradeId = row.id;
      this.versionPublishForm.cunwAppId = row.campusApp ? row.campusApp.id : '';
      this.versionPublishForm.upgradeType = row.campusApp ? row.campusApp.upgradeType : '';
      this.versionPublishForm.upgradeMethodOptions = row.campusApp ? row.campusApp.upgradeMethodOptions : null;
      this.versionPublishForm.silentInstall = row.silentInstall;
      this.versionPublishForm.upgradeMethod = row.upgradeMethod.toString() || '';
      this.versionPublishForm.timesArry = times;
      this.resetForm(1);
      const option = { campusAppId: this.versionPublishForm.cunwAppId, typeCode: this.typeCode };
      campusAppGroupslist(option.campusAppId, option)
        .then((result) => {
          this.schoolGroupList = result.data;
        })
        .catch((err) => {
          console.log(err);
          this.schoolGroupList = [];
        });
    },
    handlepublish() {
      console.log(this.versionPublishForm.timesArry);
      console.log(this.versionPublishForm.schoolGroupIds);
      this.$refs['versionPublishForm'].validate((valid) => {
        if (valid) {
          this.ajaxLoading = true;
          // 处理定时时段的数据
          var timeFrame = [];
          this.versionPublishForm.timesArry.forEach((item) => {
            var time = {};
            time.startTime = item.time[0];
            time.endTime = item.time[1];
            timeFrame.push(time);
          });
          var option = {
            areaCodes: this.versionPublishForm.areaCode ? [this.versionPublishForm.areaCode] : [],
            schoolCodes: this.versionPublishForm.schoolCode ? [this.versionPublishForm.schoolCode] : [],
            buildingIds: this.versionPublishForm.buildingId,
            roomIds: this.versionPublishForm.roomId,
            gradeCodes: this.versionPublishForm.gradeId,
            classCodes: this.versionPublishForm.classCode,
            typeCode: this.typeCode,
            silentInstall: this.versionPublishForm.silentInstall,
            upgradeMethod: this.versionPublishForm.upgradeMethod ? parseInt(this.versionPublishForm.upgradeMethod) : '',
            silentInstallTimeframes: timeFrame,
            upgradeRang: this.versionPublishForm.upgradeRang,
            schoolGroupIds: this.versionPublishForm.schoolGroupIds,
            campusAppVersionId: this.versionPublishForm.cunwAppUpgradeId
          };
          console.log(option);
          campusVersionsRelease(option.campusAppVersionId, option)
            .then((res) => {
              this.$notify.success({
                title: 'Success',
                message: '发布成功',
                showClose: false,
                duration: 2000
              });
              this.hiddenVariable.dialogpublishVisible = false;
              this.fetchApplicationList();
              this.resetForm(1);
              this.ajaxLoading = false;
            })
            .catch((err) => {
              this.ajaxLoading = false;
              console.log(err);
            });
        }
      });
    },
    // 选择区域
    handleChange(val) {
      this.versionPublishForm.areaCode = val;
      this.resetForm(2);
      this.$store.dispatch('getNodesSchool', this.versionPublishForm.areaCode);
    },
    // 重置内容
    resetForm(type) {
      if (type !== 2) this.versionPublishForm.areaCode = '';
      this.versionPublishForm.schoolCode = '';
      this.versionPublishForm.buildingId = [];
      this.versionPublishForm.roomId = [];
      this.versionPublishForm.gradeId = [];
      this.versionPublishForm.classCode = [];
      this.versionPublishForm.upgradeRang = 2;
      this.versionPublishForm.schoolGroupIds = [];
      this._schoollist = [];
      this._roomlist = [];
      this.roomSimpleVOList = [];
      this._gradelist = [];
      this.classVOList = []; // 班级列表
    },
    // 选择学校
    handleChangeSchool(val) {
      this.versionPublishForm.schoolCode = val;
      if (this.versionPublishForm.upgradeType === 1) {
        this.getNodesChanageclass();
      } else if (this.versionPublishForm.upgradeType === 2) {
        this.getNodesChanageroom();
      }
    },
    // 选择教室
    handleChangeroomSimpleVOList(val) {
      this.versionPublishForm.roomId = val;
      var result = [];
      for (var a = 0; a < val.length; a++) {
        this.roomlist.forEach((item) => {
          if (item.roomSimpleVOList && item.roomSimpleVOList.length > 0) {
            item.roomSimpleVOList.forEach((subitem) => {
              if (val[a] === subitem.roomId) {
                result.push(item.buildingId);
              }
            });
          }
        });
      }
      result = Array.from(new Set(result));
      this.versionPublishForm.buildingId = result;
    },
    // 选择楼栋
    handleChangeRoom(val) {
      if (val.length > 0) {
        this.versionPublishForm.buildingId = val;
        var result = [];
        val.forEach((item) => {
          for (var i = 0; i < this.roomVOList.length; i++) {
            if (this.roomVOList[i].buildingId === item) {
              result.push(this.roomVOList[i]);
            }
          }
        });
        var arrt = [];
        result.forEach((item) => {
          item.options.forEach((subitem) => {
            arrt.push(subitem.roomId);
          });
        });
        arrt = Array.from(new Set(arrt));
        this.versionPublishForm.roomId = arrt;
        this.roomSimpleVOList = result;
      } else {
        // TODO需要修改
        this.versionPublishForm.roomId = [];
        this.roomSimpleVOList = this.roomlist;
      }
    },
    // 选择班级
    handleChangeclassVOList(val) {
      this.versionPublishForm.classCode = val;
      var result = [];
      for (var a = 0; a < val.length; a++) {
        this.gradelist.forEach((item) => {
          if (item.classVOList && item.classVOList.length > 0) {
            item.classVOList.forEach((subitem) => {
              if (val[a] === subitem.code) {
                result.push(item.grade);
              }
            });
          }
        });
      }
      result = Array.from(new Set(result));
      this.versionPublishForm.gradeId = result;
    },

    // 选择年级
    handleupgradeType(val) {
      if (val.length > 0) {
        this.versionPublishForm.gradeId = val;
        var result = [];
        val.forEach((item) => {
          for (var i = 0; i < this.classVOListResult.length; i++) {
            if (this.classVOListResult[i].gradeId === item) {
              result.push(this.classVOListResult[i]);
            }
          }
        });
        var arrt = [];
        result.forEach((item) => {
          item.options.forEach((subitem) => {
            arrt.push(subitem.code);
          });
        });
        arrt = Array.from(new Set(arrt));
        this.versionPublishForm.classCode = arrt;
        this.classVOList = result;
      } else {
        // TODO需要修改
        this.versionPublishForm.classCode = [];
        this.classVOList = this.classVOListResult;
      }
    },
    // 获取所在教室
    getNodesChanageroom(val) {
      // 发布到教室页面回显
      this.roomSimpleVOList = [];
      const that = this;
      that.versionPublishForm.roomId = [];
      that.versionPublishForm.buildingId = [];
      var option = {
        cunwAppUpgradeId: this.versionPublishForm.cunwAppUpgradeId,
        schoolCode: this.versionPublishForm.schoolCode,
        areaCode: this.versionPublishForm.areaCode
      };
      this.$store
        .dispatch('getNodesroom', option)
        .then((result) => {
          result.forEach((item) => {
            var optionSubitem = [];
            if (item.roomSimpleVOList && item.roomSimpleVOList.length > 0) {
              item.roomSimpleVOList.forEach((subitem) => {
                optionSubitem.push(subitem);
              });
            }
            if (optionSubitem.length > 0) {
              that.roomSimpleVOList.push({
                label: item.buildingName,
                buildingId: item.buildingId,
                options: optionSubitem
              });
            }
          });
          that.roomVOList = that.roomSimpleVOList;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取所在班级
    getNodesChanageclass(val) {
      // 发布到班级页面回显
      this.classVOList = [];
      const that = this;
      that.versionPublishForm.gradeId = [];
      that.versionPublishForm.classCode = [];
      var option = {
        cunwAppUpgradeId: this.versionPublishForm.cunwAppUpgradeId,
        schoolCode: this.versionPublishForm.schoolCode,
        areaCode: this.versionPublishForm.areaCode
      };
      this.$store
        .dispatch('getNodesclass', option)
        .then((result) => {
          result.forEach((item) => {
            var optionSubitem = [];
            if (item.classVOList && item.classVOList.length > 0) {
              item.classVOList.forEach((subitem) => {
                optionSubitem.push(subitem);
              });
            }
            if (optionSubitem.length > 0) {
              that.classVOList.push({
                label: item.gradeName,
                gradeId: item.grade,
                options: optionSubitem
              });
            }
          });
          that.classVOListResult = that.classVOList;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 跳转历史页面 upgradeType 1 到班级 2 到学校
    gotoHistoryMange(row) {
      console.log(row);
      this.historyRecordPrpos = {
        campusAppVersionId: row.id,
        upgradeType: row.campusApp ? row.campusApp.upgradeType : '',
        campusAppName: row.campusApp ? row.campusApp.name : '',
        versionCode: row.versionCode
      };
      this.step = 'history';
    }
  }
};
</script>
<style lang="scss" scoped>
.AppVersionMange{
    .groupSchool{
    margin-left: 150px;
    margin-right: 120px;
    .el-checkbox-group {
      font-size: 0;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

    }
    .box-card {
      width: 150px;
      margin-bottom: 15px;
      /deep/ .el-card__header {
        padding: 12px 10px!important;
        .el-checkbox__label{
          width: 100%;
          white-space: nowrap;
          text-overflow: ellipsis;
          vertical-align: middle;
        }
      }
      /deep/ .el-card__body {
        padding: 10px 10px 5px!important;
      }
    }
    .text {
      font-size: 14px;
    }
    .item {
      margin-bottom: 8px;
    }

    .clearfix:before,
    .clearfix:after {
      display: table;
      content: "";
    }
    .clearfix:after {
      clear: both
    }

  }
}
</style>
